export default __webpack_public_path__ + "static/media/41372.5f2c59ad.gif";